<template lang="html">
  <div class="login-container">
    <div class="login-bg">
      <div class="wrapper">
        <div class="login-image-logo"></div>
        <div class="login-bg-input-area">
          <form
            v-on:submit.prevent='submitByMode(username.trim(), password)'
            @keyup.enter='submitByMode(username.trim(), password)'
            >
            <div class="">
              <label class="login-label" for="username">
                {{ (forgotPasswordMode) ? "Email" : "Username"}}
              <input class="login-input-field" type="text" name="username" v-model="username">
            </label>
            </div>
            <div class="" style="margin-top:1rem" v-if="!forgotPasswordMode">
              <label class="login-label" for="password" style="margin-top">Password
                <input class="login-input-field" type="password" name="username" v-model="password">
              </label>
            </div>
            <div v-if='!forgotPasswordMode'>
              <button
              class="login-submit-btn primary-green-bg"
              type="button"
              v-on:click="login(username.trim(), password)">Login</button>
            </div>
            <div v-else>
              <button
              class="login-submit-btn primary-green-bg"
              type="button"
              v-on:click="forgotPassword(username.trim())">Reset password</button>
            </div>
            <div class='row'>
              <div class="login-links" v-if='!forgotPasswordMode'>
                <a @click='forgotPasswordModeActivate()'>Reset/Forgot Password?</a>
            </div>
              <div class="login-links" v-else>
                <a @click='forgotPasswordModeDeactivate()'>Back to login</a>
            </div>
          </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as NameSpace from '../../store/NameSpace'
import { present, validEmail, isValidPassword } from '../../Services/Validation'
import { debounce } from 'lodash'
import { MERCHANT_ROLE } from 'src/constants/Constants'

export default {
  data () {
    return {
      username: '',
      password: '',
      credentialStatus: null,
      forgotPasswordMode: false
    }
  },
  computed: {
    ...mapGetters({
      authStateObject: NameSpace.AUTH_GETTER,
      forgotPasswordStatus: NameSpace.GET_FORGOT_PASSWORD_STATUS
    }),
    authState () {
      return this.authStateObject.auth
    },
    authError () {
      return this.authStateObject.error
    },
    forgotPasswordSuccess () {
      return this.forgotPasswordStatus.success
    },
    forgotPasswordFail () {
      return this.forgotPasswordStatus.error
    },
    isMerchant () {
      if (this.authState && this.authState.user_group) {
        return this.checkAuthorize(this.authState.user_group)
      }
    }
  },
  watch: {
    authError () {
      if (this.authError) {
        this.pop({
          header: 'Login Failed!',
          message: this.authError,
          type: 'ERROR'
        })
        this.clearErrors()
      }
    },
    authState () {
      if (this.authState.sessionToken) {
        if (this.isMerchant) {
          this.$router.push({name: 'PendingApproval'})
        }
      }
    },
    credentialStatus () {
      if (this.credentialStatus !== true) {
        this.pop(this.credentialStatus)
      }
    },
    forgotPasswordSuccess () {
      if (this.forgotPasswordSuccess) {
        this.pop({
          header: 'Success!',
          message: 'Check your email for a verification link',
          type: 'SUCCESS'
        })
      }
    },
    forgotPasswordFail () {
      if (this.forgotPasswordFail) {
        this.pop({
          header: 'Error!',
          message: this.forgotPasswordFail,
          type: 'ERROR'
        })
      }
    }
  },
  methods: {
    ...mapActions({
      authorize: NameSpace.ASYNC_AUTH_ACTION,
      clearErrors: NameSpace.CLEAR_AUTH_ERRORS_ACTION,
      pop: NameSpace.SET_MODAL_CONFIG_ACTION,
      resetPassword: NameSpace.RESET_PASSWORD
    }),
    checkAuthorize (userGroup) {
      // if (userGroup.indexOf(SUPER_USER_ROLE) !== -1) {
      //   return true
      // } else if (userGroup.indexOf(MERCHANT_ROLE) !== -1) {
      //   return true
      // } else {
      //   return false
      // }
      if (userGroup.indexOf(MERCHANT_ROLE) !== -1) {
        return true
      } else {
        return false
      }
    },
    resetLoginForm () {
      this.username = ''
      this.password = ''
    },
    forgotPasswordModeActivate () {
      this.forgotPasswordMode = true
      this.username = ''
    },
    forgotPasswordModeDeactivate () {
      this.forgotPasswordMode = false
      this.username = ''
    },
    forgotPassword (username) {
      if (typeof username === 'string' && username.trim().length > 0) {
        this.resetPassword(username)
        this.resetLoginForm()
      }
    },
    verifyCredentials (username, password) {
      if (!present(username, password)) {
        if (username.trim().length === 0 && password.trim().length === 0) {
          return {
            header: 'Invalid Input!',
            message: 'Email and password cannot be blank.',
            type: 'ERROR'
          }
        } else if (username.trim().length === 0) {
          return {
            header: 'Invalid Input!',
            message: 'Email cannot be blank.',
            type: 'ERROR'
          }
        } else if (password.trim().length === 0) {
          let msg = 'Password cannot be blank.'
          if (!validEmail(username)) {
            msg = 'Email format is not valid and password cannot be blank.'
          }
          return {
            header: 'Invalid Input!',
            message: msg,
            type: 'ERROR'
          }
        }
      } else {
        if (!validEmail(username)) {
          return {
            header: 'Invalid Input!',
            message: 'Email format is not valid.',
            type: 'ERROR'
          }
        } else if (!isValidPassword(password)) {
          // return {
          //   header: 'Invalid Input!',
          //   message: 'Password is not valid.',
          //   type: 'ERROR'
          // }
        }
      }
      return true
    },
    login (username, password) {
      debounce(function (username, password) {
        this.credentialStatus = this.verifyCredentials(username, password)
        if (this.credentialStatus === true) {
          this.authorize({username, password})
          this.resetLoginForm()
        }
      }, 1000).call(this, username, password)
    },
    submitByMode (username, password) {
      if (this.forgotPasswordMode) {
        this.forgotPassword(username)
      } else {
        this.login(username, password)
      }
    }
  }
}
</script>

<style scoped>
  .login-container {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }

  .login-bg {
    width: 100vw;
    height: 100vh;
    background: url('../../assets/Main_page_Bg.jpg');
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;
    overflow: auto;
    background-position: bottom;
  }

  .login-bg-input-area {
    background-color: rgba(255, 255, 255, .13);
    border-radius: .2rem;
    margin: 0;
    position: absolute;
    top: 33.33vh;
  }

  .login-label {
    position: relative;
    font-size: 1.5rem;
    color: white;
    letter-spacing: .15rem;
    text-transform: uppercase;
    font-size: 1.2rem;
    padding: 0;
  }

  .login-input-field {
    width: 100%;
    font-size: 1.5rem;
    background-color : #d1d1d1;
    border: 0px solid;
    display: block;
    padding: 0.6rem;
    margin-top: 0.6rem;
  }

  .login-submit-btn {
    margin-top: 3rem;
    padding-top: .2em;
    padding-bottom: .2em;
    height: 2.8em;
  }

  .login-links {
    font-size: 1.5rem;
    margin-top: 2rem;
    padding-left: 0;
    display: inline-block;
  }

  .login-links a {
    letter-spacing: .05rem;
    color: white;
    cursor: pointer;
  }

  .login-image-logo {
    background-image: url('../../assets/PSP_Logo.png');
    background-repeat: no-repeat;
    background-size: 100%;
    z-index: 1;
    width: 30rem;
    height: 10%;
    position: absolute;
    top: 5rem;
    left: 50%;
    transform: translateX(-50%);
  }

  .wrapper {
    position: absolute;
    width: 30vw;
    height: 100vh;
    right: 5rem;
  }

@media only screen and (min-width: 100px) {
  .login-bg-input-area {
    padding: 1rem 2rem;
    width: 90%;
  }
}

@media only screen and (min-width: 700px) {
  .login-bg-input-area {
    padding: 2rem;
    width: 70%;
  }
}

@media only screen and (min-width: 800px) {
  .login-bg-input-area {
    padding: 2rem;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// Login.vue?d23e4eae